(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('AdministrationService', ['$http', '$translate', '$localStorage', 'tmhDynamicLocale', AdministrationServiceFn]);

    /* load basic administrative components */
    function AdministrationServiceFn($http, $translate, $localStorage, tmhDynamicLocale) {

        var baseUrl = '/api/administrations/';
        var service = {
            countries: countries,
            medicaldisciplines: medicaldisciplines,            
            roles: roles,
            labelRoles: labelRoles,
            rolesForUser: rolesForUser,
            contactinfotypes: contactinfotypes,
            languages: languages,
            phonemasks: phonemasks,
            templatePrefixes: templatePrefixes,
            colors: colors,
            grouppractices: grouppractices,
            informationAboutDate: informationAboutDate,
            refreshToken: refreshToken,
            setLanguage: setLanguage,
            getSupportEmail: getSupportEmail,
            badges: badges,
            internalLocations: internalLocations,
            getIPAddress: getIPAddress
        };

        return service;


        /* execute request */
        function execute(request) {
            return $http.get(request).then(function (response) { return response.data; });
        }

        // set language for view
        function setLanguage(language) {
            // set new translations
            $translate.use(language.isoLangCode);
            // save new Language in Storage
            $localStorage.CurrentLanguage = language;
            // set language globally for date & time display
            moment.locale(language.momentShortCut);
            // set new locale
            tmhDynamicLocale.set(language.momentShortCut);

        } // setLanguage


        // refresh api token
        function refreshToken(languageId) {
            return $http.put(baseUrl + 'token/' + languageId).then(function (response) {
                return JSON.parse(response.data); // todo-alex: on .net core 2 this one
                //return response.data;
            });
        }


        /* get calendar information about date */
        function informationAboutDate(date, weekStartDay) {
            return execute(baseUrl + "dateinformation/" + date + '/' + weekStartDay);
        }

        /* list all countries */
        function countries() {
            return execute(baseUrl + 'countries');
        }

        /* list med. disciplines by language */
        function medicaldisciplines(languageId) {
            return execute(baseUrl + 'medicaldisciplines/' + languageId);
        }
               
        /* list all roles */
        function roles() {
            return execute(baseUrl + 'roles');
        }

        /* list label roles */
        function labelRoles() {
            return execute(baseUrl + 'roles/label');
        }

        /* list all roles that the logged-in user has access to */
        function rolesForUser(userId) {
            return execute(baseUrl + 'roles/' + userId + '/false/false');
        }

        /* list all contact info types */
        function contactinfotypes() {
            return execute(baseUrl + 'contactinfotypes');
        }

        /* list all languages */
        function languages() {
            return execute(baseUrl + 'languages');
        }

        /* list all phonemasks */
        function phonemasks() {
            return execute(baseUrl + 'phonemasks');
        }

        /* list all css templates for licence branding */
        function templatePrefixes() {
            return execute(baseUrl + 'templatePrefixes');
        }

        /* list all colors */
        function colors() {
            return execute(baseUrl + 'colors');
        }

        /* list all grouppractices */
        function grouppractices(includeEmpty) {
            return $http.get('/api/grouppractices')
                        .then(function (response) { 
                            var groupPractices = response.data || [];
                            if (includeEmpty) {
                                groupPractices.unshift({
                                    id: null,
                                    name: ' - '
                                });
                            }

                            return groupPractices;
                        });            
        }

        function internalLocations(groupPracticeId, includeEmptyItem) {
            return $http.get(`/api/grouppractices/${groupPracticeId}/internal-locations`)
                        .then(function (response) { 
                            var locations = response.data || [];
                            if (includeEmptyItem) {
                                locations.unshift({
                                    id: null,
                                    name: ' - '
                                });
                            }

                            return locations;
                        });          
        }

        function getIPAddress() {
            return execute(baseUrl + 'ipaddress');
        }

        /* get support email from appsettings */
        function getSupportEmail() {
            return execute(baseUrl + 'supportmail');
        }

        /* get updated badge numbers */
        function badges(userId, clientId, agendaId, languageId) {
            return $http.get(baseUrl + 'badges/' + userId + '/' + clientId + '/agendas/' + agendaId + '/' + languageId).then(function (response) {
                return response.data;
            });
        }

    }
})();